'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _makeStyles = require('../../makeStyles');

var _makeStyles2 = _interopRequireDefault(_makeStyles);

var _Button = require('../../Button');

var _Button2 = _interopRequireDefault(_Button);

var _Breadcrumbs = require('@material-ui/core/Breadcrumbs');

var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);

var _initial = require('lodash/initial');

var _initial2 = _interopRequireDefault(_initial);

var _tokens = require('../../styles/tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _makeStyles2.default)(function (theme) {
    return {
        breadcrumbs: {
            fontFamily: _tokens.fontFamilyDefault,
            fontSize: _tokens.fontSizeSmall
        }
    };
});

/**
 * Renders a breadcrumb element representing the current position in the hierarchy.
 */
var MasterDetailBreadcrumbs = function MasterDetailBreadcrumbs(props) {
    var selectedPath = props.selectedPath,
        rootTitle = props.rootTitle,
        onNodeSelect = props.onNodeSelect;


    var localClasses = useStyles();

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _Breadcrumbs2.default,
            { className: localClasses.breadcrumbs, maxItems: 3 },
            _react2.default.createElement(
                _Button2.default,
                {
                    key: 'active',
                    variant: 'text',
                    textVariantStyling: _Button.TEXT_STYLING_INLINE,
                    disabled: true
                },
                rootTitle
            ),
            (0, _initial2.default)(selectedPath).map(function (item) {
                return _react2.default.createElement(
                    _Button2.default,
                    {
                        key: item.nodeId,
                        variant: 'text',
                        textVariantStyling: _Button.TEXT_STYLING_INLINE,
                        onClick: function onClick(e) {
                            return onNodeSelect(e, item);
                        }
                    },
                    item.label
                );
            })
        )
    );
};

MasterDetailBreadcrumbs.propTypes = {
    selectedPath: _propTypes2.default.array,
    rootTitle: _propTypes2.default.string,
    onNodeSelect: _propTypes2.default.func
};

exports.default = MasterDetailBreadcrumbs;